import {
  registerApplication,
  start,
  addErrorHandler,
  removeErrorHandler,
  navigateToUrl,
} from "single-spa";

// registerApplication({
//   name: "@single-spa/welcome",
//   app: () =>
//     System.import(
//       "https://unpkg.com/single-spa-welcome/dist/single-spa-welcome.js"
//     ),
//   activeWhen: ["/"],
// });

registerApplication({
  name: "@sleek/customer-main",
  app: () => System.import("@sleek/customer-main"),
  activeWhen: ["/customer"],
});

registerApplication({
  name: "@sleek/customer-session",
  app: () => System.import("@sleek/customer-session"),
  activeWhen: ["/i/session"],
});

registerApplication({
  name: "@sleek/customer-sba",
  app: () => System.import("@sleek/customer-sba"),
  activeWhen: ["/sba"],
});

registerApplication({
  name: "@sleek/customer-onboarding",
  app: () => System.import("@sleek/customer-onboarding"),
  activeWhen: ["/customer-onboarding"],
});

registerApplication({
  name: "@sleek/customer-acquisition",
  app: () => System.import("@sleek/customer-acquisition"),
  activeWhen: ["/acquisition"],
});

registerApplication({
  name: "@sleek/customer-dashboard",
  app: () => System.import("@sleek/customer-dashboard"),
  activeWhen: ["/customer-dashboard"],
});

registerApplication({
  name: "@sleek/customer-auth",
  app: () => System.import("@sleek/customer-auth"),
  activeWhen: ["/auth", "/"],
});

registerApplication({
  name: "@sleek/customer-accounting",
  app: () => System.import("@sleek/customer-accounting"),
  activeWhen: ["/customer-accounting"],
});

registerApplication({
  name: "@sleek/customer-sign",
  app: () => System.import("@sleek/customer-sign"),
  activeWhen: ["/sleek-sign", "/sleek-sign-free"],
});

registerApplication({
  name: "@sleek/customer-onboarding-v2",
  app: () => System.import("@sleek/customer-onboarding-v2"),
  activeWhen: ["/customer-onboarding-v2"],
});

registerApplication({
  name: "@sleek/customer-billing",
  app: () => System.import("@sleek/customer-billing"),
  activeWhen: ["/billing", "/billing/payment"],
});

addErrorHandler(handleErr);
removeErrorHandler(handleErr);

function handleErr(err) {
  // eslint-disable-next-line no-console
  console.log(err);
}

start({
  urlRerouteOnly: true,
});

checkPath();

function checkPath() {
  const INDEX_PATHS = ["/", "/customer/", "/customer", "/main/", "/main"];
  if (INDEX_PATHS.includes(window.location.pathname)) {
    return navigateToUrl("/auth" + window.location.search);
  }

  const path = window.location.pathname.split("/")[1];
  const ALLOWED_PATHS = [
    "i",
    "lib",
    "imgs",
    "images",
    "viewer",
    "downloadables",
    "customer",
    "sba",
    "customer-onboarding",
    "acquisition",
    "customer-dashboard",
    "auth",
    "sleek-sign",
    "sleek-sign-free",
    "customer-onboarding-v2",
    "customer-accounting",
    "billing",
  ];

  if (path === "business-account") {
    navigateToUrl("/sba/business-account" + window.location.search);
    return;
  }

  // SA-34821: Migration to Acquisition MFE
  if (
    path === "customer" &&
    window.location.pathname.includes("customer/package")
  ) {
    const acquisitionPath = window.location.pathname.replace(
      "customer/package",
      "acquisition/package"
    );
    navigateToUrl(acquisitionPath + window.location.search);
    return;
  }

  if (path === "") {
    return navigateToUrl("/auth" + window.location.search);
  }

  if (!ALLOWED_PATHS.includes(path)) {
    navigateToUrl(
      "/customer" +
        window.location.pathname.replace("/main", "") +
        window.location.search
    );
  }
}
